import React, { useEffect, useState } from 'react'
import AdminLayout from '../../../layouts/AdminLayout'
// import { useAccordionButton } from 'react-bootstrap';
import CalendarBooking from '../components/CalendarBooking';
import { addDays, differenceInDays, format, parseISO, startOfDay, subDays } from 'date-fns';
import FullPageSpinner from '../../../shared/components/spinner/FullPageSpinner';
import FullPageError from '../../../shared/components/errors/FullPageError';
import CalendarFilter from '../components/calendar/CalendarFilter';
import JumpToDateRangeControl from '../components/JumpToDateRangeControl';
import { toast } from 'sonner';
import MapRoomCalendar from '../utils/MapRoomCalendar';
import { ResourcePayload } from '../lib/ResourcesPayload';
import { EventsPayload } from '../lib/EventsPayload';
import mapBookingEventCalendar from '../utils/mapBookingEventCalendar';
import { OccPayload } from '../lib/OccPayload';
import { mapOccCalendar } from '../utils/mapOccCalendar';
// import UpdateReservation from '../../pms-reservation/components/UpdateReservation';
import UpdateReservation from '../../pms-reservation/components/update-reservation-v4/UpdateReservationV4';
import useAvailability from '../../../services/availability-and-rates/hooks/useAvailability';
import useOccupancy from '../../../services/availability-and-rates/hooks/useOccupancy';
import useDataCalendar from '../../../services/availability-and-rates/hooks/useDataCalendar';
import useGetAllRoomType from '../../../services/room-type/hooks/useGetAllRoomType';
import useIndexRatePlan from '../../../services/rate-plan/hooks/useIndexRatePlan';
import { Button, Dropdown, Form } from 'react-bootstrap';
import UnsigmentRoomModal from '../components/UnsigmentRoomModal';
import { useAuth } from '../../../auth/context/AuthProvider';
import useIndexRoomMaintenance from '../../../services/room-maintenance/hooks/useIndexRoomMaintenance';
import UpdateRoomMaintenanceDialog from '../../room-maintenance/components/UpdateRoomMaintenanceDialog';
import RequireAuth from '../../../auth/middleware/RequireAuth';
import ChangeCommentDialog from '../../pms-reservation/components/comments/ChangeCommentDialog';
import ChangeStatusDialog from '../../pms-reservation/components/change-status/ChangeStatusDialog';
import CreateReservation from '../../pms-reservation/components/CreateReservation';
import { IconSettings } from '@tabler/icons-react';
import { useNavigate } from 'react-router';
import { NAVIGATION_URLS } from '../../../shared/utils/urls';
import useOccupancyMonth from '../../../services/occupancy/hooks/useOccupancyMonth';
// import JumpToDateDialog from '../components/JumpToDateDialog';
import AddPaymentDialog from '../../pms-reservation/components/add-payments/AddPaymentDialog';
import AddExtraDialog from '../../pms-reservation/components/add-extra/AddExtraDialog';
import useIndexHousekeeping from '../../../services/housekeeping/hooks/useIndexHousekeeping';
import AllUnassignedRooms from '../components/AllUnassignedRooms';
import JumpToDateDialogV2 from '../components/JumpToDateDialogV2';
import FixIncompleteBookingModal from '../../pms-reservation/components/fix-incomplete-booking/FixIncompleteBookingModal';
import { usePropertyReadOnly } from '../../../shared/hooks/usePropertyReadOnly';
import ReadOnlyGuard from '../../../shared/components/ReadOnlyGuard';
import PropertyInactiveBanner from '../../../shared/components/PropertyInactiveBanner';
// import useIndexHousekeeping from '../../../services/housekeeping/hooks/useIndexHousekeeping';

const CalendarPage: React.FC = () => {
    const { user } = useAuth();
    const { isReadOnly } = usePropertyReadOnly();

    const [todayDate, setTodayDate] = useState<string>('');
    const [date30DaysFromNow, setDate30DaysFromNow] = useState<string>('');
    const [isModalFilterOpen, setIsModalFilterOpen] = useState<boolean>(false);

    const [resourcesPayload, setResourcesPayload] = useState<ResourcePayload[]>([]);
    const [eventsPayload, setEventsPayload] = useState<EventsPayload[]>([]);
    const [occupancyPayload, setOccupancyPayload] = useState<OccPayload[]>([]);

    const [showUpdate, setShowUpdate] = useState<boolean>(false)
    const [idWithUpdate, setIdWithUpdate] = useState<string>('')

    // State modal Fix Incomplete Booking, mengikuti pola showUpdate/idWithUpdate
    // di atas (modal move-reservation sendiri statenya ada di CalendarBooking.tsx,
    // bukan di sini).
    const [fixItBookingId, setFixItBookingId] = useState<string>('')

    const [showUpdateRoomMaintenance, setShowUpdateRoomMaintenance] = useState<boolean>(false)
    const [idWithUpdateRoomMaintenance, setIdWithUpdateRoomMaintenance] = useState<string>('')

    const [showUnsigment, setShowUnsigment] = useState<boolean>(false)
    const [showBaseOnRoomType, setShowBaseOnRoomType] = useState<string>('')
    // Tampilkan baris kamar berstatus 'closed'. Booking di dalamnya otomatis ikut
    // muncul karena mapBookingEventCalendar memetakan SEMUA booking ke room_id-nya
    // — selama ini event tersebut dibuang diam-diam oleh FullCalendar karena
    // resource-nya tidak ada. Tidak persisten (reset saat reload), mengikuti
    // pola showUnsigment.
    const [showClosedRooms, setShowClosedRooms] = useState<boolean>(false)

    const [showUpdateComment, setShowUpdateComment] = useState<boolean>(false)
    const [idWillUpdateComment, setIdWillUpdateComment] = useState<string>('')
    const [showUpdateStatus, setShowUpdateStatus] = useState<boolean>(false)
    const [idWillUpdateStatus, setIdWillUpdateStatus] = useState<string>('')

    const [startDate, setStartDate] = useState<string>('');
    const [endDate, setEndDate] = useState<string>('');
    const [showCreate, setShowCreate] = useState<boolean>(false);
    const [roomTypeIdWillCreate, setRoomTypeIdWillCreate] = useState<string>('');
    const [roomIdWillCreate, setRoomIdWillCreate] = useState<string>('');

    useEffect(() => {
        // Deteksi apakah device mobile
        const isMobile = window.innerWidth <= 768;

        // Jika mobile, gunakan hari ini
        // Jika desktop, kurangi 7 hari
        const baseDate = isMobile ? new Date() : subDays(new Date(), 7);

        const today = startOfDay(baseDate); // Today is now 7 days ago
        const date30Days = startOfDay(addDays(new Date(), 30)); // 30 hari dari hari ini, waktu diatur ke awal hari

        // Mengonversi tanggal ke format 'yyyy-MM-dd'
        const formattedToday = format(today, 'yyyy-MM-dd');
        const formatted30DaysFromNow = format(date30Days, 'yyyy-MM-dd');

        // Set tanggal hari ini
        setTodayDate(formattedToday);

        // Set tanggal 30 hari dari hari ini
        setDate30DaysFromNow(formatted30DaysFromNow);
    }, []);

    const { data: rooms, isLoading: isRoomsLoading, isError: isRoomsError, error: roomsError, isSuccess: isRoomsSuccess } = useGetAllRoomType({
        all: true
    });

    const { data: ratePlans } = useIndexRatePlan({ all: true });

    const { data: availability, isLoading: isAviLoading, isError: isAviError, error: aviError, isSuccess: isAviSuccess } = useAvailability({
        gte: todayDate,
        lte: date30DaysFromNow
    });

    const { data: occupancy, isLoading: isOccLoading, isError: isOccError, error: occError, isSuccess: isOccSuccess } = useOccupancy({
        gte: todayDate,
        lte: date30DaysFromNow
    });

    const { data: occMonthly } = useOccupancyMonth({
        filter: {
            start: todayDate,
            end: date30DaysFromNow,
            property_id: user?.active_property_id ?? ''
        },
        enabled: !!user?.active_property_id, // Pastikan query ini selalu aktif
    });

    const { data: bookings, isLoading, isError, error, isSuccess } = useDataCalendar({
        gte: todayDate,
        lte: date30DaysFromNow,
        property_id: user?.active_property_id,
        query: 'booking',
    });

    const { data: housekeeping, isFetching: isHousekeepingFetching, isSuccess: isHousekeepingSuccess } = useIndexHousekeeping({
        filters: {
            property_id: user?.active_property_id,
            periode: 'now'
        },
        all: 1
    });

    const [unsigmentTodayDate, setUnsigmentTodayDate] = useState<string>('');
    const [unsigmentDate30DaysFromNow, setUnsigmentDate30DaysFromNow] = useState<string>('');

    useEffect(() => {
        if (todayDate) {
            const today = new Date(todayDate);
            const threeMonthsFromNow = new Date(today);
            threeMonthsFromNow.setMonth(today.getMonth() + 3); // Tambah 3 bulan

            setUnsigmentTodayDate(today.toISOString().split("T")[0]); // Format YYYY-MM-DD
            setUnsigmentDate30DaysFromNow(threeMonthsFromNow.toISOString().split("T")[0]);
        }
    }, [todayDate]);


    const { data: unsigmentRoomsData, isSuccess: isUnsigmentRoomsSuccess } = useDataCalendar({
        query: 'unsigment',
        gte: unsigmentTodayDate,
        lte: unsigmentDate30DaysFromNow,
        room_id: 'unassigned',
        property_id: user?.active_property_id,
    });

    const { data: roomMaintenance } = useIndexRoomMaintenance({
        filters: {
            date: {
                gte: todayDate,
                lte: date30DaysFromNow
            }
        },
        include: 'property,roomType,room',
        all: 1
    });

    useEffect(() => {
        if (isError && error || isRoomsError && roomsError || isAviError && aviError || isOccError && occError) {
            console.error('Failed to fetch bookings', error);
            console.error('Failed to fetch room types', roomsError);
            console.error('Failed to fetch availability', aviError);
            console.error('Failed to fetch occupancy', occError);
            toast.error('Failed to fetch bookings', { id: 'fetch-bookings' });
        }
    }, [isError, error, isRoomsError, roomsError, isAviError, aviError, isOccError, occError]);

    useEffect(() => {
        if (rooms && housekeeping) {
            console.log('Room types ready to mapping');
            const mapped = MapRoomCalendar({ roomTypes: rooms, isUnsigmentChecked: showUnsigment, showBaseOnRoomType, housekeeping, showClosedRooms });

            // Baris top-level "Needs Attention" -- sibling dari room type, BUKAN
            // child-nya, karena booking di sini tidak punya room_type_id sama
            // sekali (tidak ada tempat untuk ditaruh di dalam struktur room type
            // manapun). Cuma muncul kalau memang ada booking tanpa room_type_id
            // di rentang tanggal yang sedang dilihat (hindari baris kosong).
            const hasNeedsAttentionBooking = !!bookings?.data?.some((b) => !b.room_type_id);
            const resourcesWithNeedsAttention = hasNeedsAttentionBooking
                ? [{
                    id: 'needs-attention',
                    property_id: '',
                    channex_id: '',
                    title: 'Needs Attention',
                    description: null,
                    no_of_beds: 0,
                    cut_of_days: 0,
                    is_free_allotment: false,
                    is_auto_assign: false,
                    is_dynamic_pricing: false,
                    total_rooms: 0,
                    created_at: new Date().toISOString(),
                    updated_at: new Date().toISOString(),
                    occ_adults: 0,
                    occ_children: 0,
                    occ_infants: 0,
                    default_occupancy: 0,
                    room_kind: '',
                    capacity: 0,
                    order: 0, // di atas semua room type (yang mulai dari index+1)
                    children: [],
                    // BUKAN 'roomType': CalendarBooking menandai baris ber-type
                    // 'roomType' dengan class `fc-resource-roomtype` yang memaksa
                    // tinggi baris 24px (header room type memang cuma memuat
                    // angka availability). Baris ini memuat event booking
                    // sungguhan setinggi 30px, jadi kalau ikut 'roomType'
                    // pill-nya melimpah ~8px ke baris room type di bawahnya.
                    type: 'needsAttention',
                }, ...mapped]
                : mapped;

            setResourcesPayload(resourcesWithNeedsAttention);
        }
    }, [rooms, showUnsigment, showBaseOnRoomType, housekeeping, showClosedRooms, bookings]);

    // useEffect(() => {
    //     if (rooms) {
    //         console.log('Room types ready to mapping');
    //         setResourcesPayload(MapRoomCalendar({ roomTypes: rooms, isUnsigmentChecked: showUnsigment, showBaseOnRoomType }));
    //     }
    // }, [rooms, showUnsigment, showBaseOnRoomType]);

    useEffect(() => {
        if (occupancy) {
            console.log('Occupancy ready to mapping');
            setOccupancyPayload(mapOccCalendar({ occupancy }));
        }
    }, [occupancy]);

    useEffect(() => {
        if (bookings && availability && unsigmentRoomsData && roomMaintenance) {
            console.log('Bookings ready to mapping');
            setEventsPayload(mapBookingEventCalendar({ booking: bookings, availability: availability, unasigment: unsigmentRoomsData, isUnsigmentChecked: showUnsigment, showBaseOnRoomType, roomMaintenance }));
        }
    }, [bookings, availability, unsigmentRoomsData, showUnsigment, showBaseOnRoomType, roomMaintenance]);

    const handleOpenUpdate = (id: string) => {
        setIdWithUpdate(id)
        setShowUpdate(true)
    }

    const handleCloseUpdate = () => {
        setIdWithUpdate('')
        setShowUpdate(false)
    }

    const handleOpenFixIt = (id: string) => {
        if (isReadOnly) return;
        setFixItBookingId(id)
    }

    const handleCloseFixIt = () => {
        setFixItBookingId('')
    }

    // Klik blok room maintenance di kalender reservasi utama (event-nya tidak
    // punya pembungkus RequireAuth seperti tombol/menu lain), jadi guard
    // permission-nya wajib di sini — dialog-nya sendiri tetap dibungkus
    // RequireAuth juga sebagai lapisan kedua.
    const handleOpenUpdateRoomMaintenance = (id: string) => {
        if (isReadOnly) return;
        const authorized = user?.role.includes('dev') || user?.permissions.includes('room_maintenance_update');
        if (!authorized) return;
        setIdWithUpdateRoomMaintenance(id)
        setShowUpdateRoomMaintenance(true)
    }

    const handleCloseUpdateRoomMaintenance = () => {
        setIdWithUpdateRoomMaintenance('')
        setShowUpdateRoomMaintenance(false)
    }

    const isLoadingData = isLoading || isAviLoading || isOccLoading || isRoomsLoading || isHousekeepingFetching;
    // const isLoadingData = isLoading || isAviLoading || isOccLoading || isRoomsLoading;
    const isMappingEmpty = resourcesPayload.length === 0 || eventsPayload.length === 0 || occupancyPayload.length === 0;

    const isDataReady =
        isSuccess &&
        isRoomsSuccess &&
        isAviSuccess &&
        isOccSuccess &&
        isHousekeepingSuccess &&
        resourcesPayload.length > 0 &&
        eventsPayload.length > 0 &&
        occupancyPayload.length > 0;

    // const isDataReady =
    //     isSuccess &&
    //     isRoomsSuccess &&
    //     isAviSuccess &&
    //     isOccSuccess &&
    //     resourcesPayload.length > 0 &&
    //     eventsPayload.length > 0 &&
    //     occupancyPayload.length > 0;

    const [show, setShow] = useState(false);
    const [filterDate, setFilterDate] = useState("");

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    // const handleSetUnsigmentByRoomType = (roomType: string, checkinDate: string, checkoutDate: string) => {
    //     // todayDate, date30DaysFromNow ini adalah kondisi rentang tanggal yang tampil di kalender
    //     // checkinDate, checkoutDate merupakan tanggal checkin dan checkout dari sebuah event
    //     // Jika checkinDate dan checkoutDate berada di rentang tanggal yang tampil di kalender
    //     // Maka event tersebut akan ditampilkan di kalender
    //     // Jika event tersebut tidak ada dalam rentang tanggal yang tampil di kalender
    //     // Maka rentang calendar akan dimajukan bulannya sesuai dengan tanggal checkin dan checkout
    //     // Sehingga event tersebut akan ditampilkan di kalender

    //     setShowBaseOnRoomType(roomType)
    // }

    const handleSetUnsigmentByRoomType = (
        roomType: string,
        checkinDate: string,
        checkoutDate: string
    ) => {
        setShowBaseOnRoomType(roomType);

        const checkin = new Date(checkinDate);
        const checkout = new Date(checkoutDate);
        const today = new Date(todayDate); // Rentang awal kalender
        const date30DaysFromNowLocal = new Date(date30DaysFromNow); // Rentang akhir kalender

        // Jika checkin dan checkout berada dalam rentang kalender, tidak perlu ubah rentang
        if (
            (checkin >= today && checkin <= date30DaysFromNowLocal) ||
            (checkout >= today && checkout <= date30DaysFromNowLocal)
        ) {
            return;
        }

        // Jika checkin atau checkout di luar rentang, majukan rentang kalender sesuai checkin
        const newStartDate = checkin;
        const newEndDate = new Date(newStartDate);
        newEndDate.setDate(newStartDate.getDate() + 30);

        setTodayDate(format(newStartDate, 'yyyy-MM-dd'));
        setDate30DaysFromNow(format(newEndDate, 'yyyy-MM-dd'));
    };

    const handleUpdateComment = (id: string) => {
        if (isReadOnly) return;
        setIdWillUpdateComment(id)
        setShowUpdateComment(true)
    }

    const handleCloseUpdateComment = () => {
        setIdWillUpdateComment('')
        setShowUpdateComment(false)
    }

    const handleUpdateStatus = (id: string) => {
        if (isReadOnly) return;
        setIdWillUpdateStatus(id)
        setShowUpdateStatus(true)
    }

    const handleCloseUpdateStatus = () => {
        setIdWillUpdateStatus('')
        setShowUpdateStatus(false)
    }

    const [idWillUpdatePayment, setIdWillUpdatePayment] = useState<string>('');
    const [showUpdatePayment, setShowUpdatePayment] = useState<boolean>(false);

    const handleUpdatePayment = (id: string) => {
        if (isReadOnly) return;
        setIdWillUpdatePayment(id);
        setShowUpdatePayment(true);
    };

    const handleCloseUpdatePayment = () => {
        setIdWillUpdatePayment('');
        setShowUpdatePayment(false);
    };

    const [idWillAddExtra, setIdWillAddExtra] = useState<string>('');
    const [showAddExtra, setShowAddExtra] = useState<boolean>(false);

    const handleAddExtra = (id: string) => {
        if (isReadOnly) return;
        setIdWillAddExtra(id);
        setShowAddExtra(true);
    };

    const handleCloseAddExtra = () => {
        setIdWillAddExtra('');
        setShowAddExtra(false);
    };

    const handleMultipleDate = (startDate: string, endDate: string, roomTypeId: string, roomId: string) => {
        if (isReadOnly) return;
        const newStartDate = format(parseISO(startDate), 'yyyy-MM-dd')
        const newEndDate = format(parseISO(endDate), 'yyyy-MM-dd')

        const differenceDays = differenceInDays(parseISO(newEndDate), parseISO(newStartDate))

        if (differenceDays >= 1) {
            setStartDate(newStartDate)
            setEndDate(newEndDate)
        } else {
            const sumDate = addDays(new Date(endDate), 1)
            setStartDate(newStartDate)
            setEndDate(format(sumDate, 'yyyy-MM-dd'))
            console.log('sumDate', format(sumDate, 'yyyy-MM-dd'))
        }

        if (roomTypeId) {
            setRoomTypeIdWillCreate(roomTypeId)
        }

        if (roomId) {
            setRoomIdWillCreate(roomId)
        }

        setShowCreate(true)
    };

    const [showJumpToDateDialog, setShowJumpToDateDialog] = useState<boolean>(false);

    const [showAllUnassigned, setShowAllUnassigned] = useState<boolean>(false);

    // Property baru belum punya room type / rate plan -> tampilkan petunjuk setup,
    // bukan kalender kosong. Guard ini WAJIB setelah semua hook: return lebih awal
    // di antara hook membuat jumlah hook berubah antar-render saat data room type
    // selesai dimuat (React error -> "Something went wrong").
    const missingRoomTypes = rooms?.data.length === 0;
    const missingRatePlans = !missingRoomTypes && ratePlans?.data.length === 0;
    if (missingRoomTypes || missingRatePlans) {
        return (
            <AdminLayout>
                <FullPageNoData missingRoomTypes={missingRoomTypes} />
            </AdminLayout>
        )
    }

    return (
        <AdminLayout>
            {(isError || isRoomsError || isAviError || isOccError) && <FullPageError />}
            {(isLoadingData || isMappingEmpty) && <FullPageSpinner />}
            {
                isDataReady && (
                    <div className="page mt-1 vh-100 bg-white">
                        <div className="page-body mt-0">
                            <div className="container-fluid px-0">
                                <PropertyInactiveBanner variant="full" />
                                <div className='d-flex justify-content-between align-items-center' style={{ maxWidth: '100%' }}>
                                    <div className="d-sm-flex align-items-center p-2 d-none">
                                        <Form.Check
                                            type="checkbox"
                                            label="Show all unassigned rooms"
                                            className='mb-0 me-4'
                                            checked={showUnsigment}
                                            onChange={(e) => {
                                                setShowBaseOnRoomType('')
                                                setShowUnsigment(e.target.checked)
                                            }}
                                        />
                                        <Form.Check
                                            type="checkbox"
                                            label="Show closed rooms"
                                            className='mb-0 me-4'
                                            checked={showClosedRooms}
                                            onChange={(e) => setShowClosedRooms(e.target.checked)}
                                        />
                                        <JumpToDateRangeControl
                                            defStartDate={todayDate}
                                            defEndDate={date30DaysFromNow}
                                            onChangeDate={(callback) => {
                                                setTodayDate(format(new Date(callback.start_date), 'yyyy-MM-dd'));
                                                setDate30DaysFromNow(format(new Date(callback.end_date), 'yyyy-MM-dd'));
                                            }}
                                        />
                                    </div>
                                    <div className='d-sm-flex d-none me-1'>
                                        {isUnsigmentRoomsSuccess && unsigmentRoomsData?.data.length > 0 && (
                                            <Button variant="danger" className="text-white" onClick={handleShow}>
                                                <span className="me-2">Unassigned Room</span>
                                                <span className="badge bg-light text-dark rounded-circle">{unsigmentRoomsData?.data.length}</span>
                                            </Button>
                                        )}
                                        <Button variant="warning" className="text-white ms-2" onClick={() => setShowAllUnassigned(true)}>
                                            View All Unassigned
                                        </Button>
                                    </div>
                                    <div className='d-flex d-sm-none p-2 align-items-center justify-content-between' style={{ minWidth: '100%' }}>
                                        <Form.Check
                                            type="checkbox"
                                            label="Show all unasigment rooms"
                                            className='mb-0 me-4'
                                            checked={showUnsigment}
                                            onChange={(e) => {
                                                setShowBaseOnRoomType('')
                                                setShowUnsigment(e.target.checked)
                                            }}
                                        />
                                        <Dropdown>
                                            <Dropdown.Toggle variant="primary" size="sm" id="dropdown-basic">
                                                Options
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                {/* Di mobile baris atas sudah padat (checkbox + tombol Options),
                                                    jadi toggle ini ditaruh di dalam dropdown, bukan sebagai
                                                    checkbox kedua yang berdesakan. */}
                                                <Dropdown.Item onClick={() => setShowClosedRooms((prev) => !prev)}>
                                                    {showClosedRooms ? 'Hide closed rooms' : 'Show closed rooms'}
                                                </Dropdown.Item>
                                                <Dropdown.Divider />
                                                <Dropdown.Item onClick={() => setShowJumpToDateDialog(true)}>Jump to Date</Dropdown.Item>
                                                {isUnsigmentRoomsSuccess && unsigmentRoomsData?.data.length > 0 && (
                                                    <Dropdown.Item onClick={handleShow} className='text-danger'>Unassigned <span className='badge bg-danger text-light rounded-circle ms-2'>{unsigmentRoomsData?.data.length}</span></Dropdown.Item>
                                                )}
                                                <Dropdown.Item onClick={() => setShowAllUnassigned(true)}>View All Unassigned</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>
                                <CalendarBooking
                                    startDate={todayDate}
                                    endDate={date30DaysFromNow}
                                    setStartDate={setTodayDate}
                                    setEndDate={setDate30DaysFromNow}
                                    setModalFilterOpen={setIsModalFilterOpen}
                                    resourcesPayload={resourcesPayload}
                                    eventsPayload={eventsPayload}
                                    occupancy={occupancyPayload}
                                    onUpdate={handleOpenUpdate}
                                    onFixIt={handleOpenFixIt}
                                    onComment={handleUpdateComment}
                                    onUpdateStatus={handleUpdateStatus}
                                    onAddPayment={handleUpdatePayment}
                                    onAddExtra={handleAddExtra}
                                    onEditRoomMaintenance={handleOpenUpdateRoomMaintenance}
                                    onMultipleDate={handleMultipleDate}
                                    occMonth={occMonthly}
                                    housekeeping={housekeeping}
                                />
                            </div>
                        </div>
                    </div>
                )
            }
            <CalendarFilter
                show={isModalFilterOpen}
                onClose={() => setIsModalFilterOpen(false)}
            />

            {/* {showJumpToDateDialog && (
                <JumpToDateDialog
                    show={showJumpToDateDialog}
                    defStartDate={todayDate}
                    defEndDate={date30DaysFromNow}
                    onClose={() => setShowJumpToDateDialog(false)}
                    onChangeDate={(callback) => {
                        setShowJumpToDateDialog(false);
                        setTodayDate(format(new Date(callback.start_date), 'yyyy-MM-dd'));
                        setDate30DaysFromNow(format(new Date(callback.end_date), 'yyyy-MM-dd'));
                    }} />
            )} */}

            {showJumpToDateDialog && (
                <JumpToDateDialogV2
                    show={showJumpToDateDialog}
                    defStartDate={todayDate}
                    defEndDate={date30DaysFromNow}
                    onClose={() => setShowJumpToDateDialog(false)}
                    onChangeDate={(callback) => {
                        setShowJumpToDateDialog(false);
                        setTodayDate(format(new Date(callback.start_date), 'yyyy-MM-dd'));
                        setDate30DaysFromNow(format(new Date(callback.end_date), 'yyyy-MM-dd'));
                    }} />
            )}

            {/* <UpdateReservation show={showUpdate} onClose={handleCloseUpdate} reservationId={idWithUpdate} /> */}
            <UpdateReservation show={showUpdate} onClose={handleCloseUpdate} bookingId={idWithUpdate} />
            {fixItBookingId && (
                <FixIncompleteBookingModal
                    show={!!fixItBookingId}
                    bookingRoomId={fixItBookingId}
                    onClose={handleCloseFixIt}
                />
            )}
            {showUpdateRoomMaintenance && idWithUpdateRoomMaintenance && (
                <RequireAuth requiredRoles={['dev']} requiredPermissions={['room_maintenance_update']} asComponent>
                    <UpdateRoomMaintenanceDialog
                        show={showUpdateRoomMaintenance}
                        id={idWithUpdateRoomMaintenance}
                        onClose={handleCloseUpdateRoomMaintenance}
                    />
                </RequireAuth>
            )}
            {isUnsigmentRoomsSuccess && unsigmentRoomsData?.data.length > 0 && (
                <UnsigmentRoomModal
                    show={show}
                    handleClose={handleClose}
                    unsigmentRooms={unsigmentRoomsData}
                    setFilterDate={setFilterDate}
                    filterDate={filterDate}
                    onOpen={handleSetUnsigmentByRoomType}
                />
            )}
            {showUpdateComment && idWillUpdateComment && (
                <ChangeCommentDialog
                    show={showUpdateComment}
                    onClose={handleCloseUpdateComment}
                    reservationId={idWillUpdateComment}
                />
            )}
            {showUpdateStatus && idWillUpdateStatus && (
                <ChangeStatusDialog
                    show={showUpdateStatus}
                    onClose={handleCloseUpdateStatus}
                    reservationId={idWillUpdateStatus}
                />
            )}
            {showUpdatePayment && idWillUpdatePayment && (
                <AddPaymentDialog
                    show={showUpdatePayment}
                    onClose={handleCloseUpdatePayment}
                    reservationId={idWillUpdatePayment}
                />
            )}
            {showAddExtra && idWillAddExtra && (
                <AddExtraDialog
                    show={showAddExtra}
                    onClose={handleCloseAddExtra}
                    reservationId={idWillAddExtra}
                />
            )}
            {showCreate && startDate && endDate && roomTypeIdWillCreate && (
                <ReadOnlyGuard mode="hide">
                    <CreateReservation
                        show={showCreate}
                        onClose={() => setShowCreate(false)}
                        startDate={startDate}
                        endDate={endDate}
                        roomTypeId={roomTypeIdWillCreate}
                        roomId={roomIdWillCreate}
                    />
                </ReadOnlyGuard>
            )}
            <AllUnassignedRooms
                show={showAllUnassigned}
                handleClose={() => setShowAllUnassigned(false)}
                onJumpToBooking={handleSetUnsigmentByRoomType}
            />
        </AdminLayout >
    )
}

export default CalendarPage

// const CustomToggle: React.FC<{ eventKey: string }> = ({ eventKey }) => {
//     const [isOpened, setIsOpened] = useState(false);

//     const decoratedOnClick = useAccordionButton(eventKey, () => setIsOpened(!isOpened));

//     return (
//         <div className="alert alert-warning m-0 p-0 border-0 bg-transparent shadow-none col-5">
//             <div className="d-flex">
//                 <div>
//                     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap='round' strokeLinejoin='round' className="icon alert-icon"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M12 9v4"></path><path d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z"></path><path d="M12 16h.01"></path></svg>
//                 </div>
//                 <div>
//                     Hello user, you have a reservation need to assign.
//                 </div>
//                 <button className="badge badge-outline text-orange ms-2 cursor-pointer" onClick={(e) => {
//                     decoratedOnClick(e);
//                 }}>{!isOpened ? 'Click to see' : 'Click to hide'}</button>
//             </div>
//         </div>
//     );
// }
// function handleMoveToUnsigned(booking: { id: number; customer_name: string; customer_surname: string; checkin_date: string; checkout_date: string; room_type: { name: string; }; }) {
//     console.log(`Moving booking for ${booking.customer_name} ${booking.customer_surname} to unsigned list.`);
//     // Here you can add the logic to move the booking to an unsigned list
//     // For example, you might update the state or make an API call to update the booking status
// }

const FullPageNoData: React.FC<{ missingRoomTypes: boolean }> = ({ missingRoomTypes }) => {
    const navigate = useNavigate();

    const handleSetup = () => {
        navigate(NAVIGATION_URLS.DASHBOARD_ADMIN_PROPERTY_SETTINGS_RATE);
    };

    return (
        <div className='d-flex justify-content-center align-items-center' style={{ height: '100%', minHeight: '100vh' }}>
            <div className='text-center'>
                <IconSettings size={72} />
                <h4 className='mt-3'>Calendar is not ready yet</h4>
                <p className='text-muted'>
                    {missingRoomTypes
                        ? 'This property has no room type or rate plan yet. Please set up a room type and a rate plan first to see the calendar.'
                        : 'This property has no rate plan yet. Please set up a rate plan first to see the calendar.'}
                </p>
                <button className='btn btn-primary' onClick={handleSetup}>
                    {missingRoomTypes ? 'Set Up Room Type & Rate Plan' : 'Set Up Rate Plan'}
                </button>
            </div>
        </div>
    );
};